export default {
    props: {
        /**
         * The value corresponding to the radio checked state
         * Use with :value.sync="mainProperty"
         */
        value: [String, Boolean],
        disabled: Boolean,
        required: Boolean,
        /**
         * If more than 1 radio button sets the same value, specify native values (like native 'value' property of radio input
         */
        nativeValue: {
            type: [String, Boolean],
            required: true,
            default: true,
        },
        name: {
            type: String,
            required: true,
        },
        /* ID is required to link <label> to correct radio */
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('update:value', value);
            },
        },
    },
};
